import { render, staticRenderFns } from "./CommutatorsChart.vue?vue&type=template&id=624da08e&scoped=true&"
import script from "./CommutatorsChart.vue?vue&type=script&lang=js&"
export * from "./CommutatorsChart.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorsChart.vue?vue&type=style&index=0&id=624da08e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624da08e",
  null
  
)

export default component.exports